import { FetchModel, GqlModelTypeFragment } from 'src/services'
import { ModelActions } from '../Actions'
import { ModelOverview } from '../Overview'
import { ActiveCredits } from '../../model.utils'

type Props = {
  model: FetchModel
  modelTypes: GqlModelTypeFragment[]
  availableCredits: ActiveCredits
}

export function ModelHeader({
  model,
  modelTypes,
  availableCredits,
}: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-[1em] medium:flex-row">
      <ModelOverview
        modelTypes={modelTypes}
        model={model}
        className="flex flex-1 flex-col"
      />
      <ModelActions
        model={model}
        className="medium:min-w-[calc(300px-1em)]"
        availableCredits={availableCredits}
      />
    </div>
  )
}
